import DividerLine from "components/common/divider/line";
import { Forward } from "components/common/Icons";
import {
  TrackedSectionNavLink,
  useClickTracking,
} from "lib/analytics/react/link";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { TYPO } from "styles/Typo";

function Planner() {
  const router = useRouter();
  const { t } = useTranslation("main");
  const meta = [
    {
      title: t("plannerPrepareTitle"),
      navkey: "explore_banner_planner",
      sub: t("plannerPrepareSub"),
      icon: <MoneyIcon />,
      onClick: () => {
        router.push("/saa/new");
      },
      dataGtmId: "explore-planner-btn",
    },

    {
      title: t("plannerPortfolioTitle"),
      navkey: "explore_banner_portfolio",
      icon: <DiagnosisIcon />,
      onClick: () => {
        router.push("/?type=portfolio");
      },
      dataGtmId: "explore-pf-btn",
    },
  ];
  return (
    <div className="py-2 space-y-2 bg-white">
      {meta.map((item, index) => (
        <TrackedSectionNavLink
          href="/saa/new"
          sectionId="explore_portfolio_promo"
          navKey={item.navkey}
          className="px-6 py-2 flex items-center gap-3 cursor-pointer"
          key={index}
          onClick={item.onClick}
          data-gtm-id={item.dataGtmId}
        >
          {item.icon}
          <div className="grow flex flex-col ">
            <span className={`${TYPO.TYPO7_SB} text-gray80 grow`}>
              {item.title}
            </span>
            {item.sub && (
              <span className={`${TYPO.TYPO8_MD} text-blue50`}>{item.sub}</span>
            )}
          </div>

          <Forward fill="gray40" width={12} height={12} />
        </TrackedSectionNavLink>
      ))}

      <DividerLine size="lg" />
    </div>
  );
}

const MoneyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_23548_26241)">
      <path
        d="M11.9984 0.845703C13.4138 0.845703 13.3868 1.3641 14.3402 1.4145C15.2936 1.4655 15.7922 1.1655 16.436 1.2603C16.8836 1.3263 17.2202 1.5261 17.453 1.7223C17.7074 1.9371 17.7494 2.3109 17.5466 2.5749L15.329 5.4561C15.1316 5.6907 15.1556 6.0381 15.3872 6.2385C18.8384 9.2283 23.0984 12.8241 23.0984 16.0527C23.0984 21.4779 18.6452 23.1567 11.9984 23.1567C5.35164 23.1567 0.898438 21.4779 0.898438 16.0527C0.898438 12.8247 5.15844 9.2283 8.60964 6.2385C8.84124 6.0381 8.86524 5.6901 8.66784 5.4561L6.45024 2.5749C6.24744 2.3109 6.28944 1.9371 6.54384 1.7223C6.77664 1.5261 7.11324 1.3263 7.56084 1.2603C8.20464 1.1655 8.70384 1.4655 9.65664 1.4145C10.61 1.3635 10.583 0.845703 11.9984 0.845703Z"
        fill="#FFC522"
      />
      <path
        d="M12.0452 6.83036C10.8806 6.83036 9.71357 6.72116 8.57477 6.50396C8.21177 6.43436 7.97417 6.08397 8.04317 5.72096C8.11277 5.35796 8.46377 5.11856 8.82617 5.18876C10.9376 5.59136 13.157 5.59316 15.2444 5.18876C15.6068 5.11616 15.9584 5.35556 16.0286 5.71856C16.0988 6.08156 15.8612 6.43256 15.4982 6.50276C14.372 6.72056 13.2104 6.82976 12.0452 6.82976V6.83036Z"
        fill="#99452E"
      />
      <path
        d="M12.1412 19.155C10.6004 19.155 9.42744 18.243 8.93664 17.6172C8.65044 17.2518 8.71464 16.7238 9.08004 16.4376C9.44364 16.1532 9.96804 16.215 10.2554 16.5762C10.3718 16.7196 11.4254 17.9448 13.0772 17.2848C13.4786 17.1246 13.6616 16.8342 13.6346 16.6296C13.5938 16.317 13.073 15.9432 12.0026 15.8148C9.36264 15.498 8.96484 14.0016 8.90544 13.5498C8.77224 12.5298 9.41544 11.5518 10.5062 11.1162C12.713 10.2366 14.3234 11.4186 14.9132 11.9676C15.2528 12.2832 15.2714 12.8154 14.9552 13.155C14.6384 13.494 14.108 13.5132 13.7678 13.197C13.2284 12.6942 12.332 12.1968 11.1284 12.6774C10.727 12.8376 10.544 13.128 10.571 13.3326C10.6118 13.6452 11.132 14.019 12.2024 14.1474C14.8424 14.4642 15.2402 15.9606 15.2996 16.4118C15.4334 17.4318 14.7896 18.4098 13.6994 18.8454C13.1498 19.0644 12.6266 19.1556 12.1406 19.1556L12.1412 19.155Z"
        fill="#FFF3CC"
      />
      <path
        d="M12.1056 12.4819C11.6418 12.4819 11.2656 12.1063 11.2656 11.6425V10.4449C11.2656 9.98107 11.6418 9.60547 12.1056 9.60547C12.5694 9.60547 12.9456 9.98107 12.9456 10.4449V11.6425C12.9456 12.1063 12.5694 12.4819 12.1056 12.4819Z"
        fill="#FFF3CC"
      />
      <path
        d="M12.1056 20.3569C11.6418 20.3569 11.2656 19.9813 11.2656 19.5175V18.3199C11.2656 17.8561 11.6418 17.4805 12.1056 17.4805C12.5694 17.4805 12.9456 17.8561 12.9456 18.3199V19.5175C12.9456 19.9813 12.5694 20.3569 12.1056 20.3569Z"
        fill="#FFF3CC"
      />
    </g>
    <defs>
      <clipPath id="clip0_23548_26241">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const DiagnosisIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_23370_28163)">
      <path
        d="M5.07055 2.25H5.38675C5.82355 2.25 6.17695 2.6034 6.17695 3.0402C6.17695 3.477 5.82355 3.8304 5.38675 3.8304H5.07055C4.36855 3.8304 3.79795 4.401 3.79795 5.103V7.8606C3.79795 10.2018 5.51935 12.1998 7.71715 12.4098C8.96215 12.5256 10.1532 12.1344 11.0711 11.2998C11.9766 10.4772 12.4962 9.3042 12.4962 8.0814V5.103C12.4962 4.401 11.9256 3.8304 11.2235 3.8304H10.527C10.0902 3.8304 9.73675 3.477 9.73675 3.0402C9.73675 2.6034 10.0902 2.25 10.527 2.25H11.2235C12.7968 2.25 14.0766 3.5298 14.0766 5.103V8.0814C14.0766 9.7476 13.3692 11.3478 12.135 12.4692C10.884 13.6062 9.26275 14.1486 7.56775 13.9818C4.56835 13.6962 2.21875 11.007 2.21875 7.8606V5.103C2.21875 3.5298 3.49855 2.25 5.07175 2.25H5.07055Z"
        fill="#949494"
      />
      <path
        d="M18.7674 18.1989C20.4339 18.1989 21.7848 16.8479 21.7848 15.1815C21.7848 13.515 20.4339 12.1641 18.7674 12.1641C17.1009 12.1641 15.75 13.515 15.75 15.1815C15.75 16.8479 17.1009 18.1989 18.7674 18.1989Z"
        fill="#949494"
      />
      <path
        d="M2.21875 7.85938H3.79855C3.79855 10.2006 5.51995 12.1986 7.71775 12.4086C8.96275 12.5244 10.1537 12.1332 11.0717 11.2986C11.9771 10.476 12.4967 9.30298 12.4967 8.08018H14.0765C14.0765 9.74638 13.3691 11.3466 12.1349 12.468C10.8839 13.605 9.26275 14.1474 7.56775 13.9806C4.56835 13.695 2.21875 11.0058 2.21875 7.85938Z"
        fill="#3D3D3D"
      />
      <path
        d="M13.4555 22.128C10.1411 22.128 7.44531 19.4316 7.44531 16.1178V13.1172H8.84871V16.1178C8.84871 18.6582 10.9151 20.7252 13.4561 20.7252C15.9971 20.7252 18.0635 18.6588 18.0635 16.1178H19.4669C19.4669 19.4322 16.7705 22.128 13.4567 22.128H13.4555Z"
        fill="#3D3D3D"
      />
      <path
        d="M18.7668 16.7132C19.6131 16.7132 20.2992 16.0272 20.2992 15.1808C20.2992 14.3345 19.6131 13.6484 18.7668 13.6484C17.9205 13.6484 17.2344 14.3345 17.2344 15.1808C17.2344 16.0272 17.9205 16.7132 18.7668 16.7132Z"
        fill="#D5D5D5"
      />
      <path
        d="M5.48613 4.18319C6.12567 4.18319 6.64412 3.66473 6.64412 3.02519C6.64412 2.38564 6.12567 1.86719 5.48613 1.86719C4.84658 1.86719 4.32812 2.38564 4.32812 3.02519C4.32812 3.66473 4.84658 4.18319 5.48613 4.18319Z"
        fill="#3D3D3D"
      />
      <path
        d="M10.408 4.18319C11.0475 4.18319 11.566 3.66473 11.566 3.02519C11.566 2.38564 11.0475 1.86719 10.408 1.86719C9.76845 1.86719 9.25 2.38564 9.25 3.02519C9.25 3.66473 9.76845 4.18319 10.408 4.18319Z"
        fill="#3D3D3D"
      />
    </g>
    <defs>
      <clipPath id="clip0_23370_28163">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Planner;
